<div class="page-title-area">
  <div class="d-table">
      <div class="d-table-cell">
          <div class="container">
              <div class="page-title-text">
                  <h2>Profile Details</h2>
                  <ul>
                      <li><a routerLink="/">Home</a></li>
                      <li><i class="icofont-simple-right"></i></li>
                      <li>Profile Details</li>
                  </ul>
              </div>
          </div>
      </div>
  </div>
</div>

<div *ngIf="user">
  <div class="company-details-area pt-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8">
                <div class="company-details-item">
                    <!-- <div class="company-details-logo">
                        <img src="assets/img/home/question_mark_2.png" alt="Logo">
                        <div class="company-logo-inner">
                            <h3>{{pservice.name}}</h3>
                            <p><i class="icofont-location-pin"></i>{{pservice.addressLine}}</p>
                        </div>
                    </div> -->

                    <!-- <div *ngIf="pservice.validated == true" class="company-details-logo">
                      <img src="assets/img/home/validated_art.png" alt="Logo">

                      <div class="company-logo-inner">
                          <h3>{{pservice.name}}</h3>
                          <p><i class="icofont-location-pin"></i>{{pservice.addressLine}}</p>
                      </div>
                    </div> -->

                    <!-- <div class="company-details-share">
                        <span>Media Handles:</span>

                        <ul>
                            <li><a href="https://www.facebook.com/" target="_blank"><i class="icofont-facebook"></i></a></li>
                            <li><a href="https://www.twitter.com/" target="_blank"><i class="icofont-twitter"></i></a></li>
                            <li><a href="https://www.instagram.com/" target="_blank"><i class="icofont-instagram"></i></a></li>
                            <li><a href="https://www.linkedin.com/" target="_blank"><i class="icofont-linkedin"></i></a></li>
                        </ul>
                    </div> -->

                    <div class="company-details-description">
                      <h3>{{pservice.name}}</h3>
                      <p><i class="icofont-location-pin"></i>{{pservice.addressLine}}</p>
                    </div>


                    <div class="company-details-description">
                        <h3>Description</h3>
                        <p>{{pservice.description}}</p>
                    </div>

                    <div class="company-details-description">
                      <h3>City</h3>
                      <p>{{pservice.city}}</p>
                  </div>


                    <div class="company-details-find">
                      <h3>Contact:</h3>

                      <ul >
                        <div id="html-content">
                          <li><a><i class="icofont-phone-circle"></i>{{pservice.primaryContactNumber}}</a></li>
                          <!-- <li><a href="#" target="_blank"><i class="icofont-facebook"></i> gable.com</a></li>
                          <li><a href="#" target="_blank"><i class="icofont-linkedin"></i> gable.com</a></li>
                          <li><a href="#" target="_blank"><i class="icofont-twitter"></i> gable.com</a></li>
                          <li><a href="#" target="_blank"><i class="icofont-google-plus"></i> gable.com</a></li> -->
                        </div>
                      </ul>
                    </div>

                  <!-- Social Media Handles -->
                    <div class="company-details-find">
                      <h3>Social Media Links:</h3>

                      <ul >
                        <div id="html-content">
                          <li><a routerLink ="/handle_edit"><i class="icofont-plus"></i> Add New</a></li>

                        </div>
                      </ul>

                      <hr/>

                      <div class="product-table">
                        <table class="table">
                          <!-- <thead>
                            <th>.....</th>
                          </thead> -->
                          <tbody>
                            <tr *ngFor="let aa of handles">
                              <td *ngIf="aa.handle == 'Facebook'">
                                <a  href="https://web.facebook.com/{{aa.handleDetail}}" target="_blank"><i class="icofont-facebook"></i> {{aa.handleDetail}}</a>
                              </td>
                              <td *ngIf="aa.handle == 'Twitter'">
                                <a href="https://www.twitter.com/{{aa.handleDetail}}" target="_blank"><i class="icofont-twitter"></i> {{aa.handleDetail}}</a>
                              </td>
                              <td *ngIf="aa.handle == 'Instagram'">
                                <a href="https://www.instagram.com/{{aa.handleDetail}}" target="_blank"><i class="icofont-instagram"></i> {{aa.handleDetail}}</a>
                              </td>
                              <td *ngIf="aa.handle == 'Linkedin'" >
                                <a href="https://www.linkedin.com/{{aa.handleDetail}}" target="_blank"><i class="icofont-linkedin"></i> {{aa.handleDetail}}</a>
                              </td>
                              <td *ngIf="aa.handle == 'You-tube'">
                                <a  href="https://www.youtube.com" target="_blank"><i class="icofont-youtube"></i> {{aa.handleDetail}}</a>
                              </td>
                              <td><a [routerLink]="['/handle_action', aa.id]"><i class="icofont-ui-edit"></i></a></td>
                              <td><a><i class="icofont-trash" (click)="confirmDelete(aa)"></i></a></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                    </div>

                     <!-- <div class="company-details-share">

                        <ul>
                            <li><a [routerLink]="['/handle_action', pservice.id]"><i class="icofont-ui-edit"></i></a></li>
                            <li><a [routerLink]="['/handle_action', pservice.id]"><i class="icofont-trash"></i></a></li>
                        </ul>
                      </div> -->


                    <div class="text-center">
                      <!-- <a class="job-details-btn" (click)="copyContact()">Edit</a> -->
                      <a class="job-details-btn" routerLink="/edit_service/{{pservice.id}}">Edit Profile Service</a>
                    </div>

                </div>
            </div>

            <div class="col-lg-4">
                <div class="company-details-item">

                    <div class="single-resume-category">
                        <h3>Profile Information</h3>

                        <ul>
                            <li>{{user.fullname}}</li>
                            <li>{{user.contact}}</li>
                            <li>{{user.address}}</li>
                            <li>{{user.email}}</li>
                        </ul>
                    </div>

                    <div class="single-resume-category single-resume-types">
                      <h3>{{category.name}}</h3>

                      <ul>
                          <li><a href="#">Total Views</a><span class="badge">{{user.serviceViews}}</span></li>
                      </ul>
                    </div>

                </div>
            </div>
        </div>
    </div>
  </div>
</div>


<div *ngIf="!user">
  <section class="privacy-area pt-100">
    <div class="container">
        <div class="privacy-item">
            <h3>Login Credentials Verification</h3>
            <p>Wait a moment while login credentials are being verified.
              <span class="spinner-border spinner-border-sm ml-2"></span>
            </p>
        </div>
    </div>
</section>
</div>


